/**
 * WordPress Dependencies
 */
import { useBlockProps, RichText, InnerBlocks } from '@wordpress/block-editor';
import { Fragment, useEffect, useRef, RawHTML } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

/**
 * External Dependencies
 */
import classNames from 'classnames';
// icons
import ICONS from '../../controls/icon-picker-control/icons';

/**
 * Internal Dependencies
 */
import { handleUniqueId } from '../../helper';
import Inspector from './inspector';
import DynamicStyle from './dynamic-style';

const Edit = props => {
    const { attributes, setAttributes, clientId, isSelected } = props;
    const { uniqueId, titleTag, title, sourceType, icon, customIcon } = attributes;

    useEffect(() => {
        handleUniqueId({ uniqueId, setAttributes, clientId });
    }, [uniqueId, setAttributes, clientId]);

    const blockProps = useBlockProps({
        className: classNames('faq-accordion-item', uniqueId)
    });

    const accordionRef = useRef(null);

    useEffect(() => {
        if (accordionRef.current) {
            const btn = accordionRef.current.querySelector('.faq-accordion-button');

            const handleClick = () => {
                const collapse = accordionRef.current.querySelector('.faq-accordion-collapse');
                const isActive = accordionRef.current.classList.contains('active');

                if (isActive) {
                    accordionRef.current.classList.remove('active');
                    btn.classList.remove('active');
                    collapse.classList.remove('active');
                } else {
                    accordionRef.current.classList.add('active');
                    btn.classList.add('active');
                    collapse.classList.add('active');
                }
            };

            btn.addEventListener('click', handleClick);
            return () => btn.removeEventListener('click', handleClick);
        }
    }, []);

    return (
        <Fragment>
            {isSelected && <Inspector {...props} />}
            <DynamicStyle {...props} />
            <div {...blockProps} ref={accordionRef}>
                <div className="faq-accordion-header">
                    <RichText
                        tagName={titleTag}
                        className="faq-accordion-button"
                        value={title}
                        onChange={v => setAttributes({ title: v })}
                        placeholder={__('Accordion Title', 'faqmate-blocks')}
                    />
                    <span className="faq-accordion-icon">{sourceType === 'library' ? ICONS[icon] : <RawHTML>{customIcon}</RawHTML>}</span>
                </div>
                <div className="faq-accordion-collapse">
                    <div className="faq-accordion-body">
                        <InnerBlocks renderAppender={() => <InnerBlocks.ButtonBlockAppender />} />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Edit;
